import React, { useContext } from 'react';

/**
 * @typedef {Object} SessionUserContextValue
 * @property {number} user_type
 * @property {string} login_jwt
 * @property {Array} roles
 * @property {(role_id: number) => boolean} hasRole
 * @property {(permission: object) => boolean} hasRolePermission
 * @property {(permission: object) => boolean} hasFeaturePermission
 * @property {number} authority_id
 * @property {number} system_type
 * @property {UserVariantType} user_variant
 * @property {string} login_origin
 */

/**
 * This context is an abstraction of the original Passport Session Context which contains
 * only the elements which are common across all projects to allow sharing of session
 * user data between the different react apps ( Passport, EHCP, EStar ).
 */
const SessionUserContext = React.createContext(/** @type {SessionUserContextValue} */ (null));
export default SessionUserContext;
export const useSessionUserContext = () =>  useContext(SessionUserContext) ;